module.exports = function (element, scrollableElement) {
    if (!element?.length) {
        return;
    }

    while (!element.is(":visible")) {
        element = element.parent();
    }

    var position;
    var $headerContent = $(".header-content");
    var stickyDisabledClass = "sticky-disabled";
    var elementOffsetTop = element.offset().top;
    var headerBypassHeight = $(window).width() > 768 ? 200 : 80; // 200 : 80 - sticky header desktop : mobile
    if (scrollableElement) {
        // Calculate the position relative to the scrollable element
        position = elementOffsetTop - scrollableElement.offset().top + scrollableElement.scrollTop();
    } else {
        position = $(window).scrollTop() >= elementOffsetTop ?
            elementOffsetTop - headerBypassHeight : elementOffsetTop;
    }

    $headerContent.addClass(stickyDisabledClass);

    setTimeout(function () {
        $headerContent.removeClass(`sticky-head ${stickyDisabledClass}`);
    }, 1000);

    var $rootScrollElement = scrollableElement ? scrollableElement : $("html, body");

    $rootScrollElement.stop().animate({
        scrollTop: position
    }, 500);
};
